export const subMenuItemExecute = (
  parentId: string,
  onSubMenuItemExecute?: (id: string, parentId: string) => void
) => {
  return onSubMenuItemExecute
    ? (id: string) => onSubMenuItemExecute(id, parentId)
    : undefined;
};
